module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.theCreateCalendarsType === 'merge') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createmerge.create_merge')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'other') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.create_calendars.other_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'room') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createrooms.create_rooms')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'club') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.club.create_club_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'kindergarten') ? _c('span', [_vm._v("Opret stuer")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.calendarTypeIsWithSchoolYear) ? _c('h3', {
    staticClass: "flex align-center marg-1-bottom"
  }, [(!_vm.isKindergarten) ? [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')))] : [_vm._v("Periode")], _vm._v(" "), _c('ChangeSchoolYear', {
    staticClass: "marg-1-left",
    attrs: {
      "whiteTheme": true
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cr-content"
  }, [_c('h3', {
    staticClass: "modal-form__titles"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createmerge.name')))]), _vm._v(" "), _vm._l((_vm.calendars), function(cal) {
    return _c('div', {
      staticClass: "modal-form-group"
    }, [_c('div', {
      staticClass: "flex create-form"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cal.name),
        expression: "cal.name"
      }],
      staticClass: "namefield",
      class: {
        'missing-input': cal.isSameName
      },
      attrs: {
        "type": "text",
        "placeholder": _vm.placeholderText
      },
      domProps: {
        "value": (cal.name)
      },
      on: {
        "keyup": _vm.checkAllForText,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cal, "name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "delete__user",
      on: {
        "click": function($event) {
          return _vm.removeCalendar(cal)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "add-more-button",
    on: {
      "click": _vm.pushNewCalendar
    }
  }, [_c('span', {
    staticClass: "plus--icon"
  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "add-more-button__text"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.someWithSameName) ? _c('p', {
    staticClass: "error-message marg-20-right warning-text"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createmerge.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
    staticClass: "submit-btn--disabled"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db23bb08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateCalendars.vue
// module id = 2138
// module chunks = 1